import { isNil } from 'lodash'

import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

export const addPriceRangeValidator: SchemaItem['x-validator'] = {
  validator(_, __, ctx) {
    const { minAddPrice, maxAddPrice } = ctx.form.values
    if (isNil(minAddPrice)) {
      return '最小加价幅度不能为空'
    }
    if (isNil(maxAddPrice)) {
      return '最大加价幅度不能为空'
    }
    if (maxAddPrice <= minAddPrice) {
      return '最大加价幅度必须大于最小加价幅度'
    }
    return null
  }
}
